import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { SABISDynamicForm } from 'sabis-dynamicform-core';
import {
  DynamicFormModel,
  EditorData,
} from 'sabis-dynamicform-core/cjs/Models/DynamicFormModel';
import {
  FileHandler,
  FormSettings,
} from 'sabis-dynamicform-core/cjs/Models/Options';

@Component({
  selector: 'sabis-dynamicform',
  templateUrl: './sabis-dynamicform.component.html',
  styleUrls: ['./sabis-dynamicform.component.scss'],
})
export class SABISDynamicformComponent implements OnInit, OnChanges {
  private _form: SABISDynamicForm | null = null;
  @Input('scId') id: number = 1;
  //@Input('settings') settings: FormSettings | null = null;
  @Input('scTemplate') template: EditorData | null = null;
  @Input('scValues') values: FormValues | null = null;
  @Input('scIsDisabled') isDisabled: boolean = false;
  @Input('scFileHandler') fileHandler: FileHandler | null = null;
  @Input('scPreviewMode') previewMode: boolean = false;

  public settings: FormSettings | null = null;
  private _templateSettings: FormSettings = {
    id: 1,
    apiUrl: null,
    formFieldsUrl: null,
    formActionUrl: null,

    filesPath: null,
    filesHandler: null,

    formFieldsContainer: '.sabis-dynamicform article .form',
    formGroupsContainer: '.sabis-dynamicform aside',
    saveProgressUrl: null,
    saveProgressContainer: null,
    saveProgressHtml: null,
    saveProgressFeedback: null,
    saveProgressValidation: null,
    additionalGroups: [],
    afterRender: null,
    reuseApplicationData: null,
    showSubmitButton: false,
    submitText: null,
    successUrl: null,
    textVariables: null,
    previewMode: false,
    onBeforeSubmit: null,
    ids: [],
    candidatePublicUIVersion: null
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['settings']) {
      this.createNewForm();
    }

    if (changes['template']) {
      this.createNewForm();
    }

    if (changes['isDisabled'] && this._form) {
      this._form.toggleDisabled(this.isDisabled);
    }

    if (changes['values']) {
      this.createNewForm();
    }
  }

  ngOnInit(): void { }

  private createNewForm(): void {
    if (!this.settings) {
      this.settings = this._templateSettings;
      this.settings.filesHandler = this.fileHandler;
      this.settings.id = this.id;
      this.settings.previewMode = this.previewMode;
    }

    if (!this.settings || !this.template) {
      return;
    }

    this._form = new SABISDynamicForm(this.settings);
    let templateModel: DynamicFormModel = {
      countryId: '',
      versionId: 1,
      editorFieldsValues: this.values,
      editorData: this.template,
    };
    this._form.loadForm(templateModel);
    this._form.toggleDisabled(this.isDisabled);
  }
  public getFormInstance(): SABISDynamicForm | null {
    return this._form;
  }
}

export interface FormValues {
  fieldsValues: { [key: string]: any | null };
}
